import EventGrid from './eventGrid';
import OperDashboard from './operDashboard';
import WeekEvent from './weekEvent';

import './monitorDashboard.css';
import { useEffect } from 'react';
import { useState } from 'react';

const DataInfoArea = ({ conn, dongList, dataSource, chngState }) => {
  const [item, setItem] = useState({
    dongCode: '',
    dongTerm: '전체',
    normalCnt: 0, //정상
    warnCnt: 0, //경고
    dangerCnt: 0, //위험
    offCnt: 0, //미작동
    planCnt: 0, //설치예정
    activeCnt: 0, //활동
    eatCnt: 0, //식사
    sleepCnt: 0, //수면
    outCnt: 0, //부재
    dangerCallCnt: 0, // 응급호출
    dangerVoiceCnt: 0, // 긴급음성
    dangerOutCnt: 0, // 부재
    temp: 0.0, // 온도
    weath: '맑음', // 날씨
  });
  useEffect(() => {
    const isClickedItem = dataSource.filter(item => item.isClicked);
    let _normal = 0;
    let _alert = 0;
    let _danger = 0;
    let _nonOper = 0;
    let _plan = 0;
    let _activity = 0;
    let _meal = 0;
    let _sleep = 0;
    let _absence = 0;
    let _dangerCallCnt = 0; // 응급호출
    let _dangerVoiceCnt = 0; // 긴급음성
    let _dangerOutCnt = 0; // 부재
    let _temp = 0.0; // 온도
    let _weath = '맑음'; // 날씨
    let _dongTerm = '전체';
    let _dongCode = '';

    if (isClickedItem.length) {
      isClickedItem.forEach(item => {
        let duplDongTerm = '';
        const wonsung = ['4413153000', '4413154000'];
        const sungjung = ['4413351000', '4413352000'];
        const ssangyong = ['4413354000', '4413355000'];
        if (wonsung.includes(item.dongCode)) {
          duplDongTerm = '원성동';
        } else if (sungjung.includes(item.dongCode)) {
          duplDongTerm = '성정동';
        } else if (ssangyong.includes(item.dongCode)) {
          duplDongTerm = '쌍용2,3동';
        }
        _normal += item.normalCnt;
        _alert += item.warnCnt;
        _danger += item.dangerCnt;
        _nonOper += item.offCnt;
        _plan += item.planCnt;
        _activity += item.activeCnt;
        _meal += item.eatCnt;
        _sleep += item.sleepCnt;
        _absence += item.outCnt;
        _dangerCallCnt += item.dangerCallCnt; // 응급호출
        _dangerVoiceCnt += item.dangerVoiceCnt; // 긴급음성
        _dangerOutCnt += item.dangerOutCnt; // 부재
        _temp = item.temp; // 온도
        _weath = item.weath; // 날씨
        _dongTerm = duplDongTerm ? duplDongTerm : item.dongTerm;
        _dongCode = item.dongCode;
      });
    } else {
      dataSource.forEach(item => {
        _normal += item.normalCnt;
        _alert += item.warnCnt;
        _danger += item.dangerCnt;
        _nonOper += item.offCnt;
        _plan += item.planCnt;
        _activity += item.activeCnt;
        _meal += item.eatCnt;
        _sleep += item.sleepCnt;
        _absence += item.outCnt;
        _dangerCallCnt += item.dangerCallCnt; // 응급호출
        _dangerVoiceCnt += item.dangerVoiceCnt; // 긴급음성
        _dangerOutCnt += item.dangerOutCnt; // 부재
        _temp = item.temp; // 온도
        _weath = item.weath; // 날씨
      });
    }
    setItem({
      ...item,
      normalCnt: _normal,
      warnCnt: _alert,
      dangerCnt: _danger,
      offCnt: _nonOper,
      planCnt: _plan,
      activeCnt: _activity,
      eatCnt: _meal,
      sleepCnt: _sleep,
      outCnt: _absence,
      dangerCallCnt: _dangerCallCnt, // 응급호출
      dangerVoiceCnt: _dangerVoiceCnt, // 긴급음성
      dangerOutCnt: _dangerOutCnt, // 부재
      temp: _temp, // 온도
      weath: _weath, // 날씨
      dongTerm: _dongTerm,
      dongCode: _dongCode,
    });
  }, [dataSource]);

  const getWeatherPng = () => {
    let currentArea = dataSource.find(v => item.dongCode === v.dongCode);
    if (!currentArea) currentArea = item;
    // console.log('currentArea', currentArea);

    let imgSrc = '/images/weather/weather_icon06.png';
    if (currentArea.weath === '구름') {
      imgSrc = '/images/weather/weather_icon01.png';
    } else if (currentArea.weath === '구름 많음') {
      imgSrc = '/images/weather/weather_icon02.png';
    } else if (currentArea.weath === '구름 조금') {
      imgSrc = '/images/weather/weather_icon03.png';
    } else if (currentArea.weath === '눈') {
      imgSrc = '/images/weather/weather_icon04.png';
    } else if (currentArea.weath === '비/눈') {
      imgSrc = '/images/weather/weather_icon05.png';
    } else if (currentArea.weath === '맑음') {
      imgSrc = '/images/weather/weather_icon06.png';
    } else if (currentArea.weath === '비') {
      imgSrc = '/images/weather/weather_icon07.png';
    } else if (currentArea.weath === '흐림') {
      imgSrc = '/images/weather/weather_icon08.png';
    } else if (currentArea.weath === '소나기') {
      imgSrc = '/images/weather/weather_icon09.png';
    } else if (currentArea.weath === '눈/비') {
      imgSrc = '/images/weather/weather_icon10.png';
    } else {
      imgSrc = '/images/weather/weather_icon06.png';
    }
    return imgSrc;
  };

  return (
    <div className="monitorDashBoardRightContent">
      <div className="MapRightTb">
        <table className="MapRightTitle">
          <tr>
            <th>
              {item.dongTerm}&nbsp;({item.normalCnt + item.warnCnt + item.dangerCnt + item.offCnt + item.planCnt}명)
            </th>
            <td>
              <img src={getWeatherPng()} alt="cloud" />
              <span>{item.temp}</span>℃
            </td>
          </tr>
        </table>
        <OperDashboard item={item} chngState={chngState} />
        <WeekEvent conn={conn} dongCode={item.dongCode} />
        <EventGrid item={item} conn={conn} dongList={dongList} dongCode={item.dongCode} />
      </div>
    </div>
  );
};

export default DataInfoArea;
